import en from 'react-phone-number-input/locale/en.json';
import nl from 'react-phone-number-input/locale/nl.json';
import fr from 'react-phone-number-input/locale/fr.json';
import de from 'react-phone-number-input/locale/de.json';
import { SupportedLocale } from 'types';


export const phoneLocales: Record<string, any> = {
    en,
    nl,
    fr,
    de,
}

export function getPhoneCountryLabels(lang: SupportedLocale): Record<string, any> {
    const baseLocale = lang.split('-')[0];
    return phoneLocales[baseLocale] ?? phoneLocales.en;
}
